// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const EditSquare: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 13"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M9.063 1.03a1.502 1.502 0 012.124 0l.283.284a1.501 1.501 0 010 2.123L6.305 8.6c-.197.2-.448.316-.722.4l-2.124.49a.377.377 0 01-.45-.45l.49-2.123a1.65 1.65 0 01.401-.743L9.063 1.03zm1.592.53a.748.748 0 00-1.06 0l-.628.627 1.346 1.346.625-.628a.75.75 0 000-1.06l-.283-.284zM4.23 7.087l-.356 1.54 1.519-.356c.157-.031.284-.101.382-.22l4.008-3.988-1.345-1.344L4.43 6.725a.744.744 0 00-.2.36zM4.875 2a.375.375 0 010 .75h-3C1.254 2.75.75 3.254.75 3.875v6.75c0 .621.504 1.125 1.125 1.125h6.75c.621 0 1.125-.504 1.125-1.125v-3c0-.206.169-.375.375-.375s.375.169.375.375v3c0 1.036-.84 1.875-1.875 1.875h-6.75A1.875 1.875 0 010 10.625v-6.75C0 2.84.84 2 1.875 2h3z" />
        </svg>
    );
};

export default React.memo(EditSquare);
